import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../Redux/hooks";
import CategoriesBar from "../../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../../globalcomponents/navbar/NavbarTwo";

import { useParams } from "react-router-dom";
import { RootState } from "../../../../store";
import { Fragment, useEffect } from "react";
import { fetchBrandById } from "../../../../Redux/ecommersProduct/slice";
import Brandproducts from "../Brandproducts";
import ProductListOne from "../../productlisting/ListProducts/ProductListOne";

const SellerPage = () => {
  const id = useParams().id;

  const disatch = useAppDispatch();
  const { currentBrand, loading, error } = useSelector(
    (state: RootState) => state.eCommerceProducts,
  );

  useEffect(() => {
    if (id) {
      disatch(fetchBrandById(id));
    }
  }, [id]);

  const productChunks = [];
  if (currentBrand?.products) {
    for (let i = 0; i < currentBrand.products.length; i += 10) {
      productChunks.push(currentBrand.products.slice(i, i + 10));
    }
  }
  if (loading.brand) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-dark" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!currentBrand) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">not found brand</div>
      </div>
    );
  }
  return (
    <>
      <div className=" display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className=" container w-80">
          <div className=" card p-1 ">
            <img
              className=" border-radius-lg"
              src={currentBrand?.image}
              alt=""
            />
          </div>
          <div className=" border-bottom p-2">
            <div className=" d-flex justify-content-between align-items-end mt-2 mb-2 px-3">
              <div>
                <h6>{currentBrand?.name}</h6>
                <div className=" d-flex justify-content-start align-items-center gap-4">
                  <div>
                    <button className=" btn btn-sm px-5 text-black btn-light shadow-dark">
                      Follow
                    </button>
                  </div>
                  <div>
                    <a href="/DealsPage">
                      <b className=" text-black fw-bold fs-6 text-uppercase letter-spacing-1">
                        All Deals
                      </b>
                    </a>
                  </div>
                  
                  <div>
                    <a href={`/Categories/${currentBrand?.products[0].categoryHierarchy.superCategory}`}>
                      <b className=" text-black fw-bold fs-6 text-uppercase letter-spacing-1">
                        More {currentBrand?.products[0].categoryHierarchy.superCategory} products
                      </b>
                    </a>
                  </div>
                  
                
                </div>
              </div>
              <div className=" w-30">
                <div className=" input-group input-group-outline input-group-sm">
                  <span className=" input-group-text">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className=" form-control fw-bold"
                    placeholder="Search all GRECIILOOKS"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className=" card p-1 ">
            <img
              className=" border-radius-lg"
              src={currentBrand?.banner?.[0]}
              alt=""
            />
          </div>

          {productChunks.map((chunk, index) => (
            <Fragment key={index}>
              <div className="row container mx-auto mt-2 mb-3">
                <Brandproducts products={chunk} />
              </div>
              {chunk.length === 10 && currentBrand.banner?.[index + 1] && (
                <div className=" card p-1">
                  <img
                    className=" border-radius-lg"
                    src={currentBrand.banner[index + 1]}
                    alt=""
                  />
                </div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" d-flex justify-content-between align-items-center p-2 shadow-card bg-white position-fixed w-100 z-index-3">
          <div>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100"></li>
          </div>
          <div className=" d-flex gap-2">
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-search fs-6 text-black"></i>
              </a>
            </li>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-bell fs-5 text-black"></i>
              </a>
            </li>
          </div>
        </div>
        <div className=" card p-1 pt-6">
          <img className=" border-radius-lg" src={currentBrand?.image} alt="" />
        </div>
        <div className=" border-bottom p-2">
          <div className=" d-flex justify-content-between align-items-end mt-2 mb-2 px-1">
            <div>
              <h6>{currentBrand.name}</h6>
              <div className=" d-flex justify-content-start align-items-center gap-4">
                <div>
                  <button className=" btn btn-sm px-5 text-black btn-light shadow-dark">
                    Follow
                  </button>
                </div>
              </div>
            </div>
            <div className=" w-60">
              <div className=" input-group input-group-outline input-group-sm">
                <span className=" input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className=" form-control fw-bold"
                  placeholder="Search all GRECIILOOKS"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="px-2 mt-2 mb-3">
          {productChunks.map((chunk, index) => (
            <Fragment key={index}>
              <div className=" mt-2">
                <Brandproducts products={chunk} />
              </div>
              {chunk.length === 10 && currentBrand.banner?.[index + 1] && (
                <div className=" card p-1">
                  <img
                    className=" border-radius-lg"
                    src={currentBrand.banner[index + 1]}
                    alt=""
                  />
                </div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default SellerPage;
